import { atom } from 'recoil';
import { IProduct } from '../../../types';

export const testProductListState = atom<IProduct[]>({
  key: 'testProductListState',
  default: []
});
